/**
 * 每日用户活跃统计组件
 */

import { useEffect, useState } from 'react';
import { message } from 'antd';
import { Chart } from '@antv/g2';
import $ from 'jquery';
import {
    UjoinParams,
    AddRequestHeaders,
} from '../../incs/FunHelper.js';
import CNF from '../../incs/Config.js';

const UserUTACD = (props) => {
    const [isRefresh, setIsRefresh] = useState(true);
    const [data, setData] = useState([]);

    useEffect(() => {
        if (props.data) {
            setData(props.data);
        } else {
            if (isRefresh) {
                //  获取数据
                const params = {
                    'time_interval': 180
                }
                $.ajax({
                    url: `${CNF.api}reports/user/utacd${UjoinParams(params)}`,
                    headers: AddRequestHeaders(),
                    crossDomain: true,
                    type: 'GET',
                    dataType: 'JSON', success: function (data) {
                        if (data.res === 0) {
                            setData(data.dat);
                            setIsRefresh(false);
                        } else {
                            message.error(data.msg, CNF.messageDuration);
                        }
                    }
                })
            }
        }
    }, [props, isRefresh]);

    useEffect(() => {
        const chart = new Chart({
            container: 'antv-g2-id',
            autoFit: true,
        });

        chart.title({
            title: '每日用户活跃统计',
            subtitle: '展示180天内每日登录人数和登录次数。',
        });

        chart.data(data);

        chart
            .line()
            .encode('x', 'date')
            .encode('y', 'count')
            .encode('color', 'type')
            .encode('shape', 'smooth')
            .scale('y', { independent: true })
            .scale('y', { nice: true })
            .scale('color', {
                range: CNF.swatches[CNF.currentSwatche],
            })
            .axis('x', { title: '日期', })
            .axis('y', { title: '', labelFormatter: (d) => (d) })
            .animate('enter', {
                type: 'pathIn',
                duration: CNF.animateDuration + 1000,
            },)
            .tooltip({
                items: [
                    (d) => {
                        if (d.type === '登录人数') {
                            return { channel: 'y', value: `${d.count}个`, }
                        } else {
                            return { channel: 'y', value: `${d.count}次`, }
                        }
                    },
                ],
            })
            .style('lineWidth', 1);
        chart.render();

        return () => {
            chart.destroy();
        }
    }, [props.collapsed, data]);

    return <div id='antv-g2-id'></div>;
}

export default UserUTACD;